import { ZUid } from "src/types/zUid";
import { apiBomUrl } from "src/common/apiUrl";
import { rest, stdParamsSerializer } from "src/common/rest";
import { zBom2a, ZBom2a } from "./Bom2aTypes";

export const urlBom2a = (short: string) =>
  apiBomUrl(`/v3/api/${short}`.replace("//", "/"));

// устная договорённость, что запрос списка бомов для сводки возвращает полный список (без пагинации)

export const loadBoms2a = async (params: {
  objectServiceId: ZUid;
  entityId: ZUid;
}): Promise<ZBom2a[]> => {
  const result = await rest.get(urlBom2a("/bom"), { params });
  return zBom2a.array().parse(result.data);
};

type ParamsCreateBom2a = {
  name: string;
  objectServiceId: ZUid;
  entityId: ZUid;
};

export const createBom2a = async (
  params: ParamsCreateBom2a,
): Promise<ZBom2a> => {
  const result = await rest.post(urlBom2a("/bom"), undefined, { params });
  return zBom2a.parse(result.data);
};

export const deleteBoms2a = async (objectServiceId: ZUid, ids: ZUid[]) => {
  await rest.delete(urlBom2a("/bom/batch"), {
    params: { objectServiceId },
    data: ids,
  });
};

export const copyBoms2aToEntity = async (
  bomIds: ZUid[], // Это id не BOM, а PomPositionRow
  targetEntityId: ZUid, // а это id не entity, а BOM, куда копируются (position определяется по типу материала, который указан в positionRow)
  // А общая иерархия такая: Entity > BOM[] > BomPosition[] (они же материалы) > BomPositionRow[]
) => {
  await rest.put(urlBom2a("/copy/copy-boms-to-entity"), undefined, {
    params: { bomIds, targetEntityId },
    paramsSerializer: stdParamsSerializer,
  });
};

export const copyBoms2aToEntities = async (
  bomIds: ZUid[],
  targetEntityIds: ZUid[],
) => {
  await rest.put(urlBom2a("/copy/copy-boms-to-entities"), undefined, {
    params: { bomIds, targetEntityIds },
    paramsSerializer: stdParamsSerializer,
  });
};
